<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputWhatsapp" });
import Icon from "../../../../elements/icon/Icon.svelte";
import Tooltip from "../../../../elements/tooltip/Tooltip.svelte";
import Copy from "../../../../elements/copy/Copy.svelte";
import { DEVICE } from "../../../../common/environment.js";
export let mobile;
export let subject = void 0;
export let isLink = true;
export let css = "";
let showTooltip = false;
$: countryCode = mobile?.countryCode === void 0 ? "" : mobile.countryCode;
$: number = mobile?.number === void 0 ? "" : mobile.number;
$: url = `https://wa.me/${countryCode}${number}?${subject === void 0 ? "" : `subject=${subject}`}`;
$: label = `+${countryCode} (0) ${number.replace(/(?<group>.{3})/gu, "$<group> ")}`;
const toggleTooltip = (event) => {
    if (DEVICE === "phone") {
        return;
    }
    showTooltip = !showTooltip;
    event.preventDefault();
};
</script>

{#if mobile !== undefined }
    {#if isLink}
        <a href = { url } class = { `s8-whatsapp ${ css } relative` } on:click = { toggleTooltip }>
            <slot>
                <Icon key = 'whatsapp' css = '!w-4 mr-1'/>
                <span class = 's8-label'>{ label }</span>
            </slot>
            <Tooltip
                isVisible = { showTooltip }
                on:click = { toggleTooltip }
                position = 'south'
                css = '!mt-1 whitespace-nowrap'
            >
                <span class = 'whitespace-nowrap'>{ label }</span>
                <Copy text = { label } css = 'ml-1' />
            </Tooltip>
        </a>
    {:else}
        <span class = { `s8-whatsapp ${ css }` }>
            <slot>
                <Icon key = 'phone' css = '!w-4 mr-1'/>
                <span>{ label }</span>
            </slot>
        </span>
    {/if}
{/if}

<style>
    a.s8-whatsapp,
    span.s8-mobile {
    display: flex
}</style>